import * as tslib_1 from "tslib";
import * as React from 'react';
import styled, { css } from 'styled-components';
var YoutubeTrailer = /** @class */ (function (_super) {
    tslib_1.__extends(YoutubeTrailer, _super);
    function YoutubeTrailer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    YoutubeTrailer.prototype.render = function () {
        return (React.createElement(Wrapper, { isMobile: this.props.isMobile },
            React.createElement("iframe", { width: "100%", height: "100%", src: "https://www.youtube.com/embed/Ug-YlS2ZydQ?autoplay=1&loop=1&modestbranding=1&controls=0", frameBorder: "0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true })));
    };
    return YoutubeTrailer;
}(React.Component));
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n    \n    width: 100%;\n    left: 3%;\n    z-index: 2;\n    border-radius: 10px;\n    overflow: hidden;\n    border: #008fdf 4px solid;\n    background-color:black;\n\n    ", "\n"], ["\n    \n    width: 100%;\n    left: 3%;\n    z-index: 2;\n    border-radius: 10px;\n    overflow: hidden;\n    border: #008fdf 4px solid;\n    background-color:black;\n\n    ",
    "\n"])), function (p) {
    return p.isMobile && css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n            border:none;\n            height:40vh;\n            width:100%;\n            left:0;\n        "], ["\n            border:none;\n            height:40vh;\n            width:100%;\n            left:0;\n        "])));
});
export default YoutubeTrailer;
var templateObject_1, templateObject_2;



//////////////////
// WEBPACK FOOTER
// ./src/Components/YoutubeTrailer.tsx
// module id = 36
// module chunks = 0